export default __webpack_public_path__ + "static/media/launching-teladoc-icon.55207c21.svg";